// extracted by mini-css-extract-plugin
module.exports = {"skip-link-container":"SkipContent_skip-link-container__fVDT9","skip-link":"SkipContent_skip-link__X2qh_"};